import Info from './Info';
import Social from './Social';

const Footer = () => (
  <footer className="dark-bg-color">
    <Info />
    <Social />
  </footer>
);

export default Footer;
